import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { config } from "@config";
import { TranslationService } from "@core-services/translation.service";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "two-fa",
	templateUrl: "./two-fa.component.html",
	styleUrls: ["two-fa.component.scss"],
	standalone: false
})
export class TwoFaComponent implements OnInit {
	private readonly segmentService = inject(SegmentService);
	private readonly rudderstackService = inject(RudderstackService);
	private readonly translationService = inject(TranslationService);

	public authCode: string = "";
	public lastLength: number = 0;

	@Input() public type: string = "send";
	@Input() public hasAutoValidation: boolean = false;
	@Input() public isChangeNumberFlow: boolean = false;
	@Input() public isInputDisabled: boolean = false;
	@Output() public save: EventEmitter<string> = new EventEmitter<string>();

	public ngOnInit(): void {
		if (this.isChangeNumberFlow) {
			this.segmentService.track({ name: "Change Phone Number 2FA Viewed" });
			this.rudderstackService.track({ name: "Change Phone Number 2FA Viewed" });
		}
	}

	public autoAccept(): void {
		if (this.authCode.length !== this.lastLength) {
			this.lastLength = this.authCode.length;
			if (this.authCode.length === 6) {
				this.done();

				if (this.hasAutoValidation) {
					this.authCode = "";
				}
			}
		}
	}

	public done(): void {
		if (this.authCode.length !== 6) {
			return;
		}
		this.save.emit(this.authCode);
	}

	public getAuthenticatorLink(): string {
		return this.translationService.getHdLink() + config.externalPaths["user2FA"]["hdLink"];
	}
}
